var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-mobile-wrapper d-md-block d-lg-none"},[_c('span',{on:{"click":function($event){return _vm.close_mobile_menu()}}},[_c('i',{staticClass:"fas fa-times"})])])}
var staticRenderFns = []

export { render, staticRenderFns }